import React from 'react'
import MaterialSymbol from './material-symbol'

const makeIconComponent = (name, extraProps) =>
  React.forwardRef(function MaterialSymbolIcon(props, ref) {
    return <MaterialSymbol ref={ref} name={name} {...extraProps} {...props} />
  })

const SelectDropdownIcon = makeIconComponent('arrow_drop_down')

const muiChipProps = {
  deleteIcon: <MaterialSymbol name="cancel" fontSize={22} fill={1} />,
}

const muiSelectProps = {
  IconComponent: SelectDropdownIcon,
}

const muiAlertProps = {
  iconMapping: {
    success: <MaterialSymbol name="check_circle" fontSize="inherit" />,
    warning: <MaterialSymbol name="warning" fontSize="inherit" />,
    error: <MaterialSymbol name="error" fontSize="inherit" />,
    info: <MaterialSymbol name="info" fontSize="inherit" />,
  },
}

const muiAutocompleteProps = {
  popupIcon: <MaterialSymbol name="arrow_drop_down" fontSize="small" />,
  closeIcon: <MaterialSymbol name="close" fontSize="small" />,
}

const materialSymbolMuiDefaults = {
  MuiChip: muiChipProps,
  MuiSelect: muiSelectProps,
  MuiNativeSelect: muiSelectProps,
  MuiAlert: muiAlertProps,
  MuiAutocomplete: muiAutocompleteProps,
}

export default materialSymbolMuiDefaults
export { SelectDropdownIcon }
